import { Button, Col, LocalizedDateTime, Menu } from '@rematter/ui-web';
import bytes from 'bytes';
import { useAtomValue, useSetAtom } from 'jotai';
import { LucideInbox, LucideTrash2 } from 'lucide-react';

import * as conversationState from '../_state/conversation.state';
import { ExtendedFileBlock } from '../_state/conversation.state';

import { ContentBox } from './ContentBox';
import { FileIcon } from './FileIcon';

export type FileCardProps = { file: ExtendedFileBlock };

export const FileCard = ({ file }: FileCardProps) => {
  const deleteFile = useSetAtom(conversationState.$deleteFile);

  return (
    <a
      className="@FileCard flex cursor-pointer gap-2 rounded-md p-1 hover:bg-neutral/5"
      href={file.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FileIcon fileName={file.filename} />
      <Col className={'w-full'}>
        <div className={'flex w-full'}>
          <span className="w-0 grow truncate text-sm font-semibold">
            {file.filename}
          </span>
        </div>
        <div className="text-sm text-neutral/60">
          {bytes(file.size ?? 0, { decimalPlaces: 0 })} •{' '}
          <LocalizedDateTime
            date={new Date(file.createdAt)}
            dateStyle="medium"
          />
        </div>
      </Col>
      <Menu
        trigger={
          <Button
            variant="text"
            color="failure"
            className={'ml-auto'}
            icon={<LucideTrash2 />}
          />
        }
        items={[
          { label: 'Yes, delete this file', onAction: () => deleteFile(file) },
        ]}
      />
    </a>
  );
};

export const TabFiles = () => {
  const conversationFiles = useAtomValue(conversationState.$conversationFiles);

  return (
    <ContentBox className="@TabFiles gap-1">
      {!conversationFiles.length && (
        <Col className={'size-full'} xCenter yCenter gap2>
          <LucideInbox className={'size-16 stroke-[0.5] opacity-50'} />
          <span className={'text-current/50'}>
            There are no files in this conversation
          </span>
        </Col>
      )}
      {conversationFiles.length > 0 && (
        <>
          <div className={'text-sm text-neutral/60 uppercase'}>
            {conversationFiles.length} files
          </div>
          <Col gap1>
            {conversationFiles.map((file) => (
              <FileCard key={file.url} file={file} />
            ))}
          </Col>
        </>
      )}
    </ContentBox>
  );
};
